import { KEEP_ASSIGNEE } from 'routing-ui/routing-rules/constants/RoutingTypes';
import { getType } from 'routing-ui/routing-rules/operators/routingRulesGetters';
export const getRoutingRuleTypeForEventTracking = routingRuleDefinition => {
  return routingRuleDefinition === KEEP_ASSIGNEE ? routingRuleDefinition : getType(routingRuleDefinition);
};